import { createSlice } from '@reduxjs/toolkit'
import { LicenseState } from '../../types/license'
import { fetchLicense, fetchLicensePlans, changeLicensePlan } from './licenseActions'

const initialState: LicenseState = {
  license: null,
  loading: false,
  error: null,
  initialized: false,
  plans: [],
  plansLoading: false,
  plansError: null,
  changing: false,
  changeError: null,
}

export const licenseSlice = createSlice({
  name: 'license',
  initialState,
  reducers: {
    clearLicense: (state) => {
      state.license = null
      state.initialized = false
      state.error = null
    },
    clearChangeError: (state) => {
      state.changeError = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLicense.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchLicense.fulfilled, (state, action) => {
        state.loading = false
        state.license = action.payload
        state.initialized = true
      })
      .addCase(fetchLicense.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload ?? 'Failed to load license'
        // Mark as initialized even on error so the app doesn't stay in a
        // permanent loading state when the backend endpoint isn't ready yet.
        state.initialized = true
      })
      .addCase(fetchLicensePlans.pending, (state) => {
        state.plansLoading = true
        state.plansError = null
      })
      .addCase(fetchLicensePlans.fulfilled, (state, action) => {
        state.plansLoading = false
        state.plans = action.payload
      })
      .addCase(fetchLicensePlans.rejected, (state, action) => {
        state.plansLoading = false
        state.plansError = action.payload ?? 'Failed to load subscription plans'
      })
      .addCase(changeLicensePlan.pending, (state) => {
        state.changing = true
        state.changeError = null
      })
      .addCase(changeLicensePlan.fulfilled, (state, action) => {
        state.changing = false
        state.license = action.payload
      })
      .addCase(changeLicensePlan.rejected, (state, action) => {
        state.changing = false
        state.changeError = action.payload ?? 'Failed to change the subscription plan'
      })
  },
})

export const { clearLicense, clearChangeError } = licenseSlice.actions
export default licenseSlice.reducer
